import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import CampaignsPage from './pages/CampaignsPage';
import DonationPage from './pages/DonationPage';
import StoriesPage from './pages/StoriesPage';
import InvolvementPage from './pages/InvolvementPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import DonatePage from './pages/DonatePage';
import AccountStatementPage from './pages/AccountStatementPage';
import VolunteerApplicationPage from './pages/VolunteerApplicationPage';
import './index.css';
import './i18n/i18n';
import './components/common/PageTransition.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="page-transition">
        <Routes>
          {/* 새로운 메인 페이지 구조 (7개 독립 페이지) */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/campaigns" element={<CampaignsPage />} />
          <Route path="/donation" element={<DonationPage />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/involvement" element={<InvolvementPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* 기존 페이지 유지 */}
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/donate/:campaignId" element={<DonatePage />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/account-statement" element={<AccountStatementPage />} />
          <Route path="/volunteer/:category" element={<VolunteerApplicationPage />} />
          <Route path="/volunteer" element={<VolunteerApplicationPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;